import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';

import { trackImpression } from '../../lib/analytics-helpers';
import { HOMEPAGE as analyticsBase } from '../../lib/analytics-constants';
import { openAuthDialog } from '../../lib/helpers';

const HomePageReg = ({ lexFrontPageDashboardTestActive }) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [showHomePageReg, setShowHomePageReg] = useState(true);
  const screenRef = useRef();

  const dashboardUrl = '/home/dashboard/home';

  useEffect(() => {
    const isLoggedIn =
      // eslint-disable-next-line no-underscore-dangle
      window?.__GLOBAL_MARKUP_INITIAL_STATE__?.isLoggedIn;

    const openRegisterAuthDialogHelper = () => {
      openAuthDialog({
        authType: 'register',
        trk: analyticsBase.trk,
        regTrackingAttributes: {
          cohort: analyticsBase.cohort,
        },
        onCleanUp: () => {
          setIsUserLoggedIn(true);
          setShowHomePageReg(false);
        },
        onSuccessActions: lexFrontPageDashboardTestActive
          ? dashboardUrl
          : () => {},
      });
    };

    const authEmbedProps = {
      el: screenRef.current,
      authType: 'register',
      flowConfig: {
        isWelcomeRegModal: true,
        enableSuccessErrorModals: false,
        isHomePageReg: true,
        openRegisterAuthDialog: openRegisterAuthDialogHelper,
      },
      version: 2,
      flow: 'no-security-question',
      trk: analyticsBase.trk,
      regTrackingAttributes: {
        entityNames: {
          authButtons: analyticsBase.entity_names.auth_buttons,
        },
        sectionName: analyticsBase.section_name,
        cohort: analyticsBase.cohort,
        additionalAttributes: analyticsBase.additional_attributes,
      },
      onSuccess() {
        trackImpression({
          entityName: analyticsBase.entity_names.success,
          sectionName: analyticsBase.section_name,
          registrationCohort: analyticsBase.cohort,
        });
        setIsUserLoggedIn(true);
      },
      onFailure() {
        trackImpression({
          entityName: analyticsBase.entity_names.error,
          sectionName: analyticsBase.section_name,
          registrationCohort: analyticsBase.cohort,
        });
      },
    };

    if (!isLoggedIn) {
      authEmbedProps.onSuccess = dashboardUrl;
    }

    window.nwapi?.ui?.showAuthEmbed(authEmbedProps);
  }, [lexFrontPageDashboardTestActive]);

  const renderHomePageReg = () => {
    if (!showHomePageReg) {
      return null;
    }

    return <div ref={screenRef} />;
  };

  const renderMyNerdwalletButton = () => {
    if (!isUserLoggedIn) {
      return null;
    }

    return (
      <div className={classes('margin-vertical-3')}>
        <Button secondary block href={dashboardUrl}>
          Go to My NerdWallet
        </Button>
      </div>
    );
  };

  return (
    <div>
      {renderHomePageReg()}
      {renderMyNerdwalletButton()}
    </div>
  );
};

HomePageReg.propTypes = {
  lexFrontPageDashboardTestActive: PropTypes.bool,
};

HomePageReg.defaultProps = {
  lexFrontPageDashboardTestActive: false,
};

export default HomePageReg;
